var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4419 3.88301C14.686 4.12709 14.686 4.52282 14.4419 4.76689L7.2955 11.9133C6.85616 12.3527 6.14385 12.3527 5.7045 11.9133L1.55806 7.76689C1.31398 7.52282 1.31398 7.12709 1.55806 6.88301C1.80214 6.63893 2.19786 6.63893 2.44194 6.88301L6.5 10.9411L13.5581 3.88301C13.8021 3.63893 14.1979 3.63893 14.4419 3.88301Z",
    fill: "#144BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTick);
export default __webpack_public_path__ + "static/media/icon-tick.02d8267c14226a2a61cb68fd81043b43.svg";
export { ForwardRef as ReactComponent };